module.exports = __webpack_public_path__ + "static/incidences-hero-2-94287f054202794c816af9aa7227102d.png";